module.exports = "/build/web/images/header-2.be1eb2a4beab88fdf9a8799335afd68f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/header-2.jpg
// module id = 123
// module chunks = 24